import { AcademicCapIcon, WrenchScrewdriverIcon } from "@heroicons/react/24/outline";
import { NavTreeItem } from "../../../components/common/navigation";
import { UserRole } from "../../../models/user.model";

// Report "branches" for the /reports left-side tree nav. A third report is a new
// entry here plus a new route + nested sub-feature — the nav shell itself doesn't change.
// See FS_05_Reporting_01 — "Few branches" scoping intent.
export const REPORT_PROFILES: NavTreeItem[] = [
  {
    id: "technology",
    label: "By Skills & Technologies",
    icon: WrenchScrewdriverIcon,
    path: "technology",
    requiredRoles: [UserRole.Admin, UserRole.Manager],
    isEnabled: true,
  },
  {
    id: "certificates",
    label: "By Certificates",
    icon: AcademicCapIcon,
    path: "certificates",
    requiredRoles: [UserRole.Admin, UserRole.Manager],
    isEnabled: true,
  },
];
